var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401.63 392.5",
    style: {
      enableBackground: "new 0 0 401.63 392.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E429F2;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 79.16,
    cy: 219.5,
    r: 70.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 200.55,
    cy: 199.27,
    r: 128.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 291.11,
    cy: 290.31,
    r: 90.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 305.96,
    cy: 93.86,
    r: 85.18
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1800.03,10700.67v-652.93l9.75,5.67c44.19,25.84,939.17,542.11,1018.49,587.66 c76.83,43.97,101.53,59.38,99.72,61.19c-1.59,1.59-168.39,98.36-371,215.07c-202.61,116.94-453.49,261.76-557.52,321.82 c-104.02,60.06-191.51,110.37-194.22,111.96l-5.21,2.72V10700.67z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1576.43,10807.15v-652.93l9.75,5.67c44.19,25.84,939.17,542.11,1018.49,587.66 c76.83,43.97,101.53,59.38,99.72,61.19c-1.59,1.59-168.39,98.36-371,215.08c-202.61,116.94-453.49,261.76-557.52,321.82 s-191.51,110.37-194.22,111.96l-5.21,2.72V10807.15z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1693.56,10871.04v-652.93l9.75,5.67c44.19,25.84,939.17,542.11,1018.49,587.66 c76.83,43.97,101.53,59.38,99.72,61.19c-1.59,1.59-168.39,98.36-371,215.08c-202.61,116.94-453.49,261.76-557.52,321.82 c-104.02,60.06-191.51,110.37-194.22,111.96l-5.21,2.72V10871.04z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1682.91,10700.67v-652.93l9.75,5.67c44.19,25.84,939.17,542.11,1018.49,587.66 c76.83,43.97,101.53,59.38,99.72,61.19c-1.59,1.59-168.39,98.36-371,215.07c-202.61,116.94-453.49,261.76-557.52,321.82 s-191.51,110.37-194.22,111.96l-5.21,2.72V10700.67z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo 2.c57182bc869130b73af351dcf38f562e.svg";
export { ForwardRef as ReactComponent };